import { FC, useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { boxStyles, tabsStyles, tabStyles } from "./YearSwitcher.styles";

interface IYearSwitcherProps {
  years: string[];
  selectedYear?: string;
  handleYearChange: (year: string) => void;
}

const YearSwitcher: FC<IYearSwitcherProps> = ({
  years,
  selectedYear,
  handleYearChange,
}) => {
  const [value, setValue] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (years.length > 0 && !isInitialized) {
      const currentYear = new Date().getFullYear().toString();
      const currentYearIndex = years.findIndex((year) => year === currentYear);

      if (currentYearIndex !== -1) {
        setValue(currentYearIndex);
      }
      setIsInitialized(true);
    }
  }, [years, isInitialized]);

  useEffect(() => {
    if (selectedYear) {
      const yearIndex = years.indexOf(selectedYear);

      if (yearIndex !== -1 && yearIndex !== value) {
        setValue(yearIndex);
      }
    }
  }, [selectedYear, years, value]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    handleYearChange(years[newValue]);
    setValue(newValue);
    setIsInitialized(true);
  };

  return (
    <Box sx={boxStyles}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        sx={tabsStyles}
        scrollButtons
        selectionFollowsFocus
        allowScrollButtonsMobile
      >
        {years.map((year) => (
          <Tab key={year} label={year} disableRipple sx={tabStyles} />
        ))}
      </Tabs>
    </Box>
  );
};

export default YearSwitcher;
